import React from "react";
import Banner from "../components/Banner";
import SignUpSection from "../components/SignUpSection";
import { useSelector } from "react-redux";

const SignUpPage = () => {
  const screen = useSelector((state) => state.userReducer.screen);
  return (
    <div className="SignUpPage">
      {screen.desktop && (<Banner />)}
      <SignUpSection />
    </div>
  );
};

export default SignUpPage;
